export default {"src":"/_next/static/media/type.3ba52c76.svg","height":56,"width":35,"blurWidth":0,"blurHeight":0};